/** @type {Record<string, readonly [string, string]>} */
export const PLAN_AND_WORKSPACE_SECTION_INTROS = {
  'plan-subscription': ['Current plan and upgrades.', 'Changes affect limits and billing on renewal.'],
  'plan-activity': ['Team usage over the past year.', 'Updates as sign-ins and actions are recorded.'],
  'plan-tokens': ['AI token usage vs. your allowance.', 'Near the cap, new AI requests may throttle until reset or upgrade.'],
  'users-metrics': ['People, roles, and access at a glance.', 'Updates when admins change the directory.'],
  'users-directory': ['Search and manage workspace users.', 'Roles and access changes apply immediately.'],
  'billing-metrics': ['Spend, invoices, and payment method.', 'Reflects the current billing period.'],
  'billing-invoices': ['Invoice history for your organization.', 'Download PDFs; status shows paid, open, or overdue.'],
  'connections-metrics': ['Connected apps and sync health.', 'Counts update as integrations sync or fail.'],
  'connections-directory': ['OAuth and workspace integrations.', 'Disconnect affects only that account or app row.'],
}
